import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
    selectedLoginMenu : null,
    list_login_game : [],
    loginDialog:false
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
